<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="courseCover"
      label-position="right"
      label-width="130px"
      style="width: 570px"
    >
      <el-form-item label="封面名称" prop="course_cover_name">
        <el-input
          v-model="courseCover.course_cover_name"
          maxlength="14"
          show-word-limit
          clearable
          placeholder="请输入课卡名称"
        />
      </el-form-item>

      <v-image-upload
        v-model="courseCover.cover"
        label="封面"
        prefix="course-cover"
        ratio="16:9"
        prop-name="cover"
        :is-edit="true"
      />

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">保存修改</el-button>
        <el-button @click="RouteConfig.courseCoverList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { show, update } from '@/api/course-cover';

export default {
  name: RouteConfig.courseCoverEdit.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    courseCover: {
      course_cover_name: '',
      cover: '',
      update_time: 0,
    },
    rules: {
      course_cover_name: [{ required: true, message: '请输入封面名称', trigger: 'change' }],
      cover: [{ required: true, message: '请上传封面', trigger: 'change' }],
    },
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const postData = { ...this.courseCover };
        const { isError } = await update(this.id, postData);
        this.isSaving = false;
        if (!isError) RouteConfig.courseCoverList.back();
      });
    },
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      const { courseCover } = this;
      const courseCoverInfo = {};
      Object.keys(data).forEach(key => {
        if (key in courseCover) courseCoverInfo[key] = data[key];
      });
      Object.assign(courseCover, courseCoverInfo);
    },
  },
};
</script>
